import clsx from "clsx"
import { FC, memo } from "react"
import { ISeparator, styleTypeMap } from "."
import styles from "./Separator.module.scss"

const SeparatorComponent: FC<ISeparator> = ({ styleType }) => {
  return (
    <div className={clsx(styles.Separator)}>
      <img src={styleTypeMap[styleType]} alt="separator" />
    </div>
  )
}

export const Separator = memo(SeparatorComponent)
